import { __rest } from "tslib";
import React from 'react';
import { mergeProps, mergeRefs } from '~/utils';
const SLOT_CLONE_NAME = 'vulcanui-slot-clone';
const SlotClone = React.forwardRef((props, forwardedRef) => {
    const { children } = props, slotProps = __rest(props, ["children"]);
    if (React.isValidElement(children)) {
        return React.cloneElement(children, Object.assign(Object.assign({}, mergeProps(slotProps, children.props)), { ref: mergeRefs([forwardedRef, children.ref]) }));
    }
    return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = 'SlotClone';
SlotClone.toString = () => `.${SLOT_CLONE_NAME}`;
export default SlotClone;
//# sourceMappingURL=slot-clone.js.map